import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import Hero from '../home/components/Hero';
import ServiceTypesSection from '../home/components/ServiceTypesSection';

export default function ReparationFenetreSolaize() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <Hero
        title="Réparation de Fenêtres à Solaize"
        subtitle="Service professionnel de réparation et dépannage de fenêtres à Solaize (69360). Intervention rapide pour tous types de fenêtres : PVC, bois, aluminium."
        backgroundImage="https://public.readdy.ai/ai/img_res/fcea7ad4a841bbd1682d5141ad0c747b.jpg"
      />
      
      <ServiceTypesSection />
      
      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Nos Services à Solaize
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-tools-line', title: 'Réparation Fenêtres PVC', desc: 'Remplacement de vitrage, joints, poignées' },
              { icon: 'ri-hammer-line', title: 'Réparation Fenêtres Alu', desc: 'Mécanismes, serrures, rails' },
              { icon: 'ri-paint-brush-line', title: 'Réparation Fenêtres Bois', desc: 'Restauration, traitement, peinture' },
              { icon: 'ri-window-line', title: 'Baies Vitrées', desc: 'Réparation et remplacement' },
              { icon: 'ri-lock-line', title: 'Quincaillerie', desc: 'Poignées, serrures, charnières' },
              { icon: 'ri-shield-check-line', title: 'Dépannage Urgent', desc: 'Intervention rapide 7j/7' }
            ].map((service, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all group">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Pourquoi Nous Choisir à Solaize ?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Sous 24h à Solaize' },
              { icon: 'ri-shield-star-line', title: 'Garantie Qualité', desc: 'Travaux garantis 2 ans' },
              { icon: 'ri-money-euro-circle-line', title: 'Devis Gratuit', desc: 'Sans engagement' },
              { icon: 'ri-customer-service-2-line', title: 'Disponible 7j/7', desc: 'À votre écoute' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
      
      <Footer />
    </div>
  );
}